import axios from 'axios';

export const updateServicePositions = async (
  servicePositions: {
    serviceId: string;
    position: number;
  }[]
): Promise<boolean> => {
  try {
    await axios.put('/api/Service/UpdatePositions', {
      servicePositions,
    });

    return true;
  } catch (err) {
    console.trace(err);
    return false;
  }
};
